<template>
  <div>
    <el-button type="success" icon="el-icon-refresh" @click="getQueueList()"
      >Reload Queue</el-button
    >
    <data-tables
      v-loading="loading"
      :data="tableData"
      border
      :page-size="20"
      :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }"
    >
      <el-table-column
        prop="createdDate"
        label="Date"
        header-align="center"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="type"
        label="Type"
        header-align="center"
        align="center"
        width="250"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="Status"
        header-align="center"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 'Success'" size="mini">{{
            scope.row.status
          }}</el-tag>
          <el-tag
            v-if="scope.row.status == 'Downloaded'"
            size="mini"
            type="success"
            >{{ scope.row.status }}</el-tag
          >
          <el-tag
            v-if="scope.row.status == 'Process'"
            size="mini"
            type="warning"
            >{{ scope.row.status }}</el-tag
          >
          <el-tag v-if="scope.row.status == 'Fail'" size="mini" type="danger">{{
            scope.row.status
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="fileName"
        label="File"
        header-align="center"
        align="center"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="reason"
        label="Reason"
        header-align="center"
        align="center"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="downloadDate"
        label="Download Date"
        header-align="center"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="uid"
        label="Action"
        header-align="center"
        align="center"
        width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            v-if="['Success'].includes(scope.row.status)"
            icon="el-icon-download"
            type="success"
            size="mini"
            @click="downloadReport(scope.row.uid, scope.row.fileName)"
            >Download</el-button
          >
        </template>
      </el-table-column>
    </data-tables>
  </div>
</template>
<!-- v-if="['success', 'downloaded'].includes(scope.row.status)" -->
<script>
import axios from 'axios';
import { getQueue } from "@/api/export-queue";
import { getToken } from '@/utils/auth'
export default {
  data() {
    return {
      tableData: [],
      loading: false,
    };
  },
  methods: {
    getQueueList() {
      this.loading = true;
      getQueue().then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.tableData = data;
        }
      });
    },
    downloadReport(uid, filename) {
      const baseURL = process.env.VUE_APP_SERVER_BASE_API;
      axios({
        url: `${baseURL}/api/exportqueue/${uid}/download`, //your url
        method: "GET",
        responseType: "blob",
        headers: {
          authorization : getToken()
        } // important
      }).then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(new Blob([response.data]));

        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
        this.getQueueList();
      });
    },
  },
  mounted() {
    this.getQueueList();
  },
};
</script>

<style lang="scss" scoped></style>
